export const MAKE_PAYMENT_REQUEST = "MAKE_PAYMENT_REQUEST";
export const MAKE_PAYMENT_SUCCESS = "MAKE_PAYMENT_SUCCESS";
export const MAKE_PAYMENT_FAILED = "MAKE_PAYMENT_FAILED";
